import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import askForOpportunities from './askForOpportunities';
import auth from './auth';
import candidateAvailability from './candidateAvailability';
import candidateOffers from './candidateOffers';
import common from './common';
import contacts from './contacts';
import dates from './dates';
import errors from './errors';
import feedback from './feedback';
import { formatDate } from './helpers';
import jobPreferences from './jobPreferences';
import myJobs from './myJobs';
import navigation from './navigation';
import profile from './profile';
import rolesSpecialtiesSelector from './rolesSpecialtiesSelector';
import validation from './validation';
import { applyYupLocale } from './yupLocale';

export const defaultNS = 'errors';

export const resources = {
    en: {
        auth: auth.en,
        errors: errors.en,
        candidateAvailability: candidateAvailability.en,
        candidateOffers: candidateOffers.en,
        common: common.en,
        contacts: contacts.en,
        dates: dates.common,
        askForOpportunities: askForOpportunities.en,
        feedback: feedback.en,
        jobPreferences: jobPreferences.en,
        navigation: navigation.en,
        profile: profile.en,
        rolesSpecialtiesSelector: rolesSpecialtiesSelector.en,
        validation: validation.en,
        myJobs: myJobs.en
    },
    no: {
        auth: auth.no,
        errors: errors.no,
        candidateAvailability: candidateAvailability.no,
        candidateOffers: candidateOffers.no,
        common: common.no,
        contacts: contacts.no,
        dates: dates.common,
        askForOpportunities: askForOpportunities.no,
        feedback: feedback.no,
        jobPreferences: jobPreferences.no,
        navigation: navigation.no,
        profile: profile.no,
        rolesSpecialtiesSelector: rolesSpecialtiesSelector.no,
        validation: validation.no,
        myJobs: myJobs.no
    },
    sv: {
        auth: auth.sv,
        errors: errors.sv,
        candidateAvailability: candidateAvailability.sv,
        candidateOffers: candidateOffers.sv,
        common: common.sv,
        contacts: contacts.sv,
        dates: dates.common,
        askForOpportunities: askForOpportunities.sv,
        feedback: feedback.sv,
        jobPreferences: jobPreferences.sv,
        navigation: navigation.sv,
        profile: profile.sv,
        rolesSpecialtiesSelector: rolesSpecialtiesSelector.sv,
        validation: validation.sv,
        myJobs: myJobs.sv
    }
} as const;

const initTranslation = () => {
    i18n.use(initReactI18next)
        .init({
            lng: 'en',
            fallbackLng: 'en',
            ns: [ 'errors', 'candidateAvailability', 'common', 'candidateOffers', 'askForOpportunities', 'feedback', 'jobPreferences', 'profile', 'rolesSpecialtiesSelector', 'contacts' ],
            interpolation: {
                escapeValue: false,
                format: formatDate
            },
            resources
        });
    
    applyYupLocale();

    i18n.on('languageChanged', applyYupLocale);
};

export { initTranslation };
